import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <h2>Introduction</h2>
        <p>
          Plate Passion ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. 
          This privacy policy explains how we collect, use, and safeguard your information when you use our recipe 
          management platform and associated services, including our Alexa skill integration.
        </p>

        <h2>Information We Collect</h2>
        
        <h3>Account Information</h3>
        <ul>
          <li>Email address</li>
          <li>Username</li>
          <li>Password (encrypted)</li>
          <li>Subscription status and payment information</li>
        </ul>

        <h3>Recipe and Usage Data</h3>
        <ul>
          <li>Recipes you create, save, or interact with</li>
          <li>Meal plans and shopping lists</li>
          <li>Ingredient preferences and customizations</li>
          <li>Recipe ratings and comments</li>
        </ul>

        <h3>Alexa Integration Data</h3>
        <ul>
          <li>Voice requests related to recipes and meal planning</li>
          <li>Alexa account linking information</li>
          <li>Usage patterns of our Alexa skill</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <ul>
          <li>To provide and maintain our recipe management service</li>
          <li>To process your subscription and payments</li>
          <li>To personalize your experience with customized meal plans</li>
          <li>To enable Alexa voice interactions with your recipes</li>
          <li>To send service-related emails (password resets, subscription updates)</li>
          <li>To improve our services based on usage patterns</li>
        </ul>

        <h2>Data Storage and Security</h2>
        <p>
          We store your data using industry-standard security measures:
        </p>
        <ul>
          <li>Encrypted passwords using bcrypt</li>
          <li>Secure HTTPS connections</li>
          <li>AWS infrastructure for data storage</li>
          <li>Regular security updates and monitoring</li>
        </ul>

        <h2>Third-Party Services</h2>
        <p>We use the following third-party services:</p>
        <ul>
          <li><strong>Stripe:</strong> For payment processing (they handle your payment information securely)</li>
          <li><strong>AWS:</strong> For hosting and image storage</li>
          <li><strong>OpenAI:</strong> For AI-powered recipe suggestions (no personal data shared)</li>
          <li><strong>Amazon Alexa:</strong> For voice-enabled recipe access (with your explicit consent)</li>
        </ul>

        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Update or correct your information</li>
          <li>Delete your account and associated data</li>
          <li>Opt-out of non-essential communications</li>
          <li>Disconnect Alexa integration at any time</li>
        </ul>

        <h2>Alexa Skill Privacy</h2>
        <p>
          When you enable our Alexa skill and link your account:
        </p>
        <ul>
          <li>We only access recipe data you've explicitly shared</li>
          <li>Voice recordings are processed by Amazon, not stored by us</li>
          <li>You can unlink your account at any time through the Alexa app</li>
          <li>We don't share your data with other Alexa users</li>
        </ul>

        <h2>Children's Privacy</h2>
        <p>
          Plate Passion is not intended for children under 13. We do not knowingly collect 
          personal information from children under 13 years of age.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this privacy policy from time to time. We will notify you of any 
          significant changes by email or through our platform.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions about this privacy policy or our data practices, 
          please contact us at: support@platepassion.com
        </p>
      </div>
    </div>
  );
};

export default Privacy;